// extracted by mini-css-extract-plugin
export const root = "about-section-module--root--Sb_BJ";
export const title = "about-section-module--title--1TVPh";
export const scrollingDown = "about-section-module--scrollingDown--3AFM3";
export const text = "about-section-module--text--GNHMX";